import { render, staticRenderFns } from "./search_B.vue?vue&type=template&id=64648d4c&scoped=true&"
import script from "./search_B.vue?vue&type=script&lang=js&"
export * from "./search_B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64648d4c",
  null
  
)

export default component.exports